var map = {
	"./aboutusjsonld/about_us_EN_at": 474,
	"./aboutusjsonld/about_us_EN_at.json": 474,
	"./aboutusjsonld/about_us_EN_es": 475,
	"./aboutusjsonld/about_us_EN_es.json": 475,
	"./aboutusjsonld/about_us_EN_nl": 476,
	"./aboutusjsonld/about_us_EN_nl.json": 476,
	"./aboutusjsonld/about_us_EN_sk": 477,
	"./aboutusjsonld/about_us_EN_sk.json": 477,
	"./aboutusjsonld/about_us_at": 478,
	"./aboutusjsonld/about_us_at.json": 478,
	"./aboutusjsonld/about_us_cz": 479,
	"./aboutusjsonld/about_us_cz.json": 479,
	"./aboutusjsonld/about_us_es": 480,
	"./aboutusjsonld/about_us_es.json": 480,
	"./aboutusjsonld/about_us_nl": 481,
	"./aboutusjsonld/about_us_nl.json": 481,
	"./aboutusjsonld/about_us_pl": 482,
	"./aboutusjsonld/about_us_pl.json": 482,
	"./aboutusjsonld/about_us_sk": 483,
	"./aboutusjsonld/about_us_sk.json": 483,
	"./faqjsonld/at": 484,
	"./faqjsonld/at.json": 484,
	"./faqjsonld/cz": 485,
	"./faqjsonld/cz.json": 485,
	"./faqjsonld/en": 486,
	"./faqjsonld/en.json": 486,
	"./faqjsonld/es": 487,
	"./faqjsonld/es.json": 487,
	"./faqjsonld/nl": 488,
	"./faqjsonld/nl.json": 488,
	"./faqjsonld/pl": 489,
	"./faqjsonld/pl.json": 489,
	"./faqjsonld/sk": 490,
	"./faqjsonld/sk.json": 490,
	"./favicon.ico": 811,
	"./images/applepay.svg": 812,
	"./images/bank_transfer.svg": 813,
	"./images/credit_card.svg": 814,
	"./images/gia-logo.svg": 815,
	"./images/gold.png": 816,
	"./images/igi-logo.svg": 817,
	"./images/klarna.svg": 818,
	"./images/no-image.webp": 819,
	"./images/payments.webp": 820,
	"./images/paypal.svg": 821,
	"./images/ros_gold.png": 822,
	"./images/silver.png": 823,
	"./images/white_gold.png": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;